module.exports = __webpack_public_path__ + "img/metergrid-logo.03cc0b36.svg";